import { useMutation } from 'react-query'

import { APIError } from '../../../../../utils'
import { voidInvoice, VoidInvoiceResponseData } from '../../../query-api'

interface UseVoidInvoiceProps {
  onError?: (error?: APIError) => void
  onSettled?: (data: VoidInvoiceResponseData | undefined, error: APIError | null | undefined) => void
  onSuccess?: (reponse: VoidInvoiceResponseData) => void
}

export const useVoidInvoice = (props?: UseVoidInvoiceProps) => {
  const { onError, onSuccess, onSettled } = props || {}
  const { mutate, ...rest } = useMutation(voidInvoice, {
    onError,
    onSuccess,
    onSettled,
  })

  return { voidInvoice: mutate, ...rest }
}
